<template>
  <div class="">
    <div class="btns">
      <el-button type="primary" size="mini" @click="addTeacher">新增</el-button>
      <el-button
        type="danger"
        size="mini"
        @click="DeleteProceQuestion"
        :disabled="this.selsectId.length == 0"
        >删除</el-button
      >
      <el-button type="danger" style="position: relative" size="mini"
        ><input
          class="upload_file"
          @input="uploadFile"
          id="file"
          type="file"
        />导入问题</el-button
      >
      <el-select
        v-if="$route.query.TypeId != '4'"
        style="margin: 0 10px"
        v-model="scopeCopy"
        @change="scopeChange"
        placeholder="请选择"
        size="mini"
      >
        <el-option
          v-for="item in scopeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button size="mini" type="primary" @click="DownFile"
        >下载模板</el-button
      >
      <!-- <el-button type="primary" @click="onClicKEdit">表格2名称</el-button> -->
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
        }"
        @selection-change="handleSelectionChange"
        empty-text="暂无数据"
      >
        <el-table-column type="selection" width="55"> </el-table-column>

        <!-- <el-table-column type="index" width="55"> </el-table-column> -->
        <el-table-column prop="Id" label="Id" width="150"> </el-table-column>
        <el-table-column prop="GradeName" width="55" label="范围">
        </el-table-column>
        <el-table-column prop="Question" label="问题"> </el-table-column>

        <el-table-column
          prop="OrderSort"
          label="排序"
          width="150"
        ></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="paginationChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center; padding: 20px 0 0 0"
      >
      </el-pagination>
    </div>
    <!-- 修改 -->
    <el-dialog width="30%" :visible.sync="showMask" title="修改">
      <div>
        <el-form
          ref="form"
          :model="editForm"
          label-width="80px"
          class="form"
          :rules="rules"
        >
          <el-form-item
            label="范围"
            style="margin-top: 20px"
            prop="name"
            v-if="$route.query.TypeId != '4'"
          >
            <el-select v-model="editForm.gradeName" placeholder="请选择">
              <el-option
                v-for="item in scopeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题" style="margin-top: 20px" prop="name">
            <el-input v-model="editForm.Question"></el-input>
          </el-form-item>
          <el-form-item label="排序" style="margin-top: 20px" prop="name">
            <el-input v-model="editForm.OrderSort"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="PreserveUpdate">提交</el-button>
        <el-button @click="closeAdd">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 添加 -->
    <el-dialog width="30%" :visible.sync="AddMask" title="新增">
      <div v-if="AddMask">
        <el-form
          ref="form"
          :model="addForm"
          label-width="80px"
          class="form"
          :rules="rules"
        >
          <el-form-item
            label="范围"
            style="margin-top: 20px"
            prop="name"
            v-if="$route.query.TypeId != '4'"
          >
            <el-select v-model="scope" placeholder="请选择">
              <el-option
                v-for="item in scopeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题" style="margin-top: 20px" prop="name">
            <el-input v-model="addForm.Question"></el-input>
          </el-form-item>
          <el-form-item label="排序" style="margin-top: 20px" prop="name">
            <el-input v-model="addForm.OrderSort"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="PreserveAdd">提交</el-button>
        <el-button @click="closeAdd">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  GetProceQuestionByPage,
  UpdateProceQuestion,
  DeleteProceQuestion,
  AddProceQuestion,
  FileUploadsExcel,
  ImportProceQuestion,
} from "../../api/api";
export default {
  data() {
    //这里存放数据
    return {
      scope: "通用",
      scopeCopy: "通用",
      scopeList: [
        {
          label: "通用",
          value: "通用",
        },
        {
          label: "大班",
          value: "大班",
        },
        {
          label: "中班",
          value: "中班",
        },
        {
          label: "小班",
          value: "小班",
        },
      ],
      excelurl: "", //上传文件返回url
      showMask: false, //编辑弹窗
      AddMask: false, //添加弹窗
      tableData: [], //教师列表
      addForm: {
        Question: "",
        OrderSort: null,
      }, //添加信息对象
      rules: {
        Question: [{ required: true, message: "请输入问题", trigger: "blur" }],
        OrderSort: [
          { required: true, message: "请选择是否置顶", trigger: "blur" },
        ],
      }, //输入框判定
      editForm: {
        gradeName: "",
        Question: "",
        OrderSort: null,
        Id: 0,
      }, //修改信息对象
      selsectId: [], //多选选中的Id
      page: 1, //初始页码
      PageSize: 10,
      total: 0, //总条数
      userInfo: {},
      loading: undefined,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 导入问题
    uploadFile(item) {
      this.excelurl = "";
      const fileObj = item.target.files[0];
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("filetype", "excel");
      if (!this.loading) {
        this.loading = this.$loading({
          lock: true,
          text: "数据导入中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
      }

      FileUploadsExcel(form).then(
        (response) => {
          if (response.data.success) {
            this.excelurl = response.data.url;
            let file = document.getElementById("file");
            file.value = ""; //file的value值只能设置为空字符串
            this.SubmitUploadFile();
          } else {
            this.$message({
              message: res.data.msg,
              type: "导入失败",
            });
            if (this.loading) {
              this.loading.close();
              this.loading = undefined;
            }
          }
        },
        (res) => {
          this.$message({
            message: res.data.msg,
            type: "导入失败",
          });
          if (this.loading) {
            this.loading.close();
            this.loading = undefined;
          }
        }
      );
    },
    //导入问题提交增加
    SubmitUploadFile() {
      if (this.excelurl) {
        ImportProceQuestion({
          fileName: this.excelurl,
          OtherName: this.$route.query.Name,
        }).then((res) => {
          if (res.data.success) {
            if (this.loading) {
              this.loading.close();
              this.loading = undefined;
            }
            this.GetProceQuestionByPage();
          } else {
            if (this.loading) {
              this.loading.close();
              this.loading = undefined;
            }
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        if (this.loading) {
          this.loading.close();
          this.loading = undefined;
        }
        this.$message({
          message: "请选择文件",
          type: "error",
        });
      }
    },
    scopeChange() {
      this.GetProceQuestionByPage();
    },
    handleSizeChange(e) {
      this.page = 1;
      this.PageSize = e;
      this.GetProceQuestionByPage();
    },
    paginationChange(e) {
      this.page = e;
      this.GetProceQuestionByPage();
    },
    //获取问题信息列表
    GetProceQuestionByPage() {
      GetProceQuestionByPage({
        PageSize: this.PageSize,
        PageIndex: this.page,
        Name: this.$route.query.Name,
        SchoolId: this.userInfo.SchoolId,
        GradeName: this.$route.query.TypeId == "4" ? "托班" : this.scopeCopy,
      }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.response.data;
          this.total = res.data.response.dataCount;
        } else {
          this.tableData = [];
        }
      });
    },
    //新增
    addTeacher() {
      this.AddMask = true;
    },
    DownFile() {
      location.href =
        "https://mushroomisand.oss-cn-shanghai.aliyuncs.com/downfile/%E8%A1%A8%E6%A0%BC2%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
    },

    //多选功能
    handleSelectionChange(val) {
      let list = [];
      val.forEach((item) => {
        if (!list.includes(item.Id)) {
          list.push(item.Id);
        }
      });
      this.selsectId = list;
    },
    //删除学校问题按钮
    DeleteProceQuestion() {
      DeleteProceQuestion({
        ids: this.selsectId,
      }).then((res) => {
        if (res.data.success) {
          this.GetProceQuestionByPage();
          if (res.data.success == true) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        }
      });
    },

    //编辑按钮
    handleEdit(index, row) {
      //console.log(row);
      this.editForm.Question = row.Question;
      this.editForm.OrderSort = row.OrderSort;
      this.editForm.gradeName = row.GradeName;
      this.editForm.Id = row.Id;
      this.showMask = true;
    },
    //提交新增信息
    PreserveAdd() {
      if (this.addForm.OrderSort && this.addForm.Question) {
        AddProceQuestion({
          Question: this.addForm.Question,
          OrderSort: this.addForm.OrderSort,
          gradeName: this.$route.query.TypeId == "4" ? "托班" : this.scope,
          Name: this.$route.query.Name,
        })
          .then((res) => {
            if (res.status == 200) {
              this.GetProceQuestionByPage();
              if (res.data.success == true) {
                this.$message({
                  message: "增加成功",
                  type: "success",
                });
              } else if (res.data.success == false) {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            }
          })
          .catch((err) => {
            this.$message({
              message: "操作失败",
              type: "error",
            });
          });
        // //console.log(this.addForm);
        this.AddMask = false;
        this.addForm = {
          Question: "",
          OrderSort: null,
        };
      } else {
        this.$message({
          message: "请补充添加信息",
        });
      }
    },
    //编辑
    PreserveUpdate() {
      //console.log(this.editForm);
      if (this.editForm.OrderSort && this.editForm.Question) {
        UpdateProceQuestion({
          gradeName:
            this.$route.query.TypeId == "4" ? "托班" : this.editForm.gradeName,
          Id: this.editForm.Id,
          Question: this.editForm.Question,
          OrderSort: this.editForm.OrderSort,
        })
          .then((res) => {
            if (res.status == 200) {
              this.GetProceQuestionByPage();
              if (res.data.success == true) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              } else if (res.data.success == false) {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            }
          })
          .catch((err) => {
            this.$message({
              message: "操作失败",
              type: "error",
            });
          });
        // //console.log(this.addForm);
        this.showMask = false;
        this.addForm = {
          Question: "",
          OrderSort: null,
          Id: 0,
        };
      } else {
        this.$message({
          message: "请补充添加信息",
        });
      }
    },
    //关闭提交模态框
    closeAdd() {
      this.AddMask = false;
      this.showMask = false;
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  mounted() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    this.GetProceQuestionByPage();
  },
};
</script>
<style scoped lang="less">
/deep/.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}
/deep/.el-dialog__header {
  background: #f2f5ff;
}
.upload_file {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  top: 0;
  left: 0;
  opacity: 0;
}
.role {
  width: 120px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  margin-left: 20px;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #999999;
  border-radius: 5px;
}
.roles {
  background: #409eff;
  color: #ffffff;
  border-color: #409eff;
}

.table {
  margin-top: 20px;
}
.paging {
  margin-left: 20px;
  margin-top: 20px;
}
.last_btn {
  margin-left: 20px !important;
}
.mask {
  width: 500px;
  height: 420px;
  position: absolute;
  z-index: 100;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(33, 51, 74, 0.2);
  left: 24%;
  top: 20%;
}
.mask .mask_title {
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  color: #333333;
  background: #dbf4ff;
  padding-left: 30px;
}
.form {
  padding: 10px 30px;
}
.editmask {
  position: absolute;
  z-index: 100;
  /* margin: 0 auto; */
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(33, 51, 74, 0.2);
  left: 30%;
  top: 0%;
}
.editmask .mask_title {
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  color: #333333;
  background: #dbf4ff;
  padding-left: 30px;
}
</style>